// extracted by mini-css-extract-plugin
module.exports = {"list":"SearchResultRoomsList-module--list--2ryVW","roomItem":"SearchResultRoomsList-module--roomItem--fCsFr"};